class Translation {
  id: number;
  value: string;
  localValue: string;

  constructor(id: number, value: string, localValue: string) {
    this.id = id;
    this.value = value;
    this.localValue = localValue;
  }
}

export { Translation };
